export default __webpack_public_path__ + "static/media/logo.cda6498a.png";